module.exports = __webpack_public_path__ + "static/media/female-bg.747e38cf.png";